import { useQuery } from '@tanstack/react-query';

import { mySuspendedMembersKey, requestMySuspendedMembers } from './membersApi';

/**
 * The rows of the directory's Suspended Members view, at the app's default staleness.
 *
 * No `Failure` variant to handle: `mySuspendedMembers` is a pure read, so infrastructure errors
 * travel the standard GraphQL errors envelope, and the directory shows them as its error state.
 */
export function useMySuspendedMembers() {
  return useQuery({ queryKey: mySuspendedMembersKey, queryFn: requestMySuspendedMembers });
}
